'use client'

import Link from 'next/link'
import { ArrowLeft } from 'lucide-react'
import SettingsComponent from '../components/SettingsComponent'
import ThemeToggle from '../components/ThemeToggle'
import { clearLocalStorage } from '../lib/utils'

export default function SettingsPage() {
  const handleResetOptions = () => {
    clearLocalStorage('options')
  }

  const handleResetHistory = () => {
    clearLocalStorage('selectionHistory')
  }

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      {/* Top bar */}
      <nav className="sticky top-0 z-40 border-b border-border bg-background/95 backdrop-blur-md">
        <div className="max-w-lg mx-auto px-5 h-12 flex items-center justify-between">
          <Link
            href="/"
            aria-label="back to home"
            className="p-2.5 flex items-center justify-center rounded-lg hover:bg-muted active:scale-95 transition-transform"
          >
            <ArrowLeft className="w-[18px] h-[18px] text-muted-foreground" />
          </Link>
          <h1 className="text-base font-semibold tracking-wide">settings</h1>
          <ThemeToggle />
        </div>
      </nav>

      {/* Main content */}
      <main className="flex-1 max-w-lg w-full mx-auto px-5 py-10 space-y-6">
        <SettingsComponent
          onResetOptions={handleResetOptions}
          onResetHistory={handleResetHistory}
        />
      </main>
    </div>
  )
}